import { Modal, ModalContent, ModalHeader, ModalBody, ModalFooter } from '@nextui-org/react';
import { CtyButton } from '../button/CtyButton';
import { useTranslation } from 'react-i18next';
import { Icon } from '@iconify/react';

export interface DownloadModalProps {
  isOpen: boolean;
  onClose: () => void;
  onDownloadPDF: () => void;
  onDownloadText: () => void;
  isDownloadingPDF?: boolean;
  isDownloadingText?: boolean;
}

export function DownloadModal({
  isOpen,
  onClose,
  onDownloadPDF,
  onDownloadText,
  isDownloadingPDF = false,
  isDownloadingText = false
}: Readonly<DownloadModalProps>) {
  const { t } = useTranslation();

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      size="md"
      placement="center"
    >
      <ModalContent>
        <ModalHeader className="flex flex-col gap-1">
          <div className="flex items-center gap-2">
            <Icon icon="material-symbols:download" width="1.5em" height="1.5em" />
            {t('Download Conversation')}
          </div>
        </ModalHeader>
        <ModalBody>
          <div className="flex flex-col gap-3">
            <CtyButton
              variant="bordered"
              size="lg"
              onPress={onDownloadPDF}
              isDisabled={isDownloadingPDF || isDownloadingText}
              isLoading={isDownloadingPDF}
              startContent={<Icon icon="material-symbols:picture-as-pdf" width="1.2em" height="1.2em" />}
              className="w-full justify-start"
            >
              {t('Download PDF')}
            </CtyButton>
            <CtyButton
              variant="bordered"
              size="lg"
              onPress={onDownloadText}
              isDisabled={isDownloadingPDF || isDownloadingText}
              isLoading={isDownloadingText}
              startContent={<Icon icon="material-symbols:text-snippet" width="1.2em" height="1.2em" />}
              className="w-full justify-start"
            >
              {t('Download Text File')}
            </CtyButton>
          </div>
        </ModalBody>
        <ModalFooter>
          <CtyButton variant="light" onPress={onClose} className="border-2 border-default-300">
            {t('Close')}
          </CtyButton>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}

